import React, { Component } from 'react'
import { Field } from "redux-form";
import TextInput from '../../../system/fields/TextInput';
import { Button, FormGroup, Label } from 'reactstrap';
import FileUpload from '../../../system/fields/FileUpload';
import Wysiwyg from '../../../system/fields/Wysiwyg';

const Faq = ({ fields }) => {
    return (
        <div className={"repeater-container"}>
            {fields.map((section, i) => (
                <React.Fragment>
                    <div className="row top-field">
                        <FormGroup className="col-12">
                            <Label>Question</Label>
                            <Field
                                name={`${section}.question`}
                                component={TextInput}
                                type="text"
                            />
                        </FormGroup>

                        <FormGroup className="col-12">
                            <Label>Answer</Label>
                            <Field
                                name={`${section}.answer`}
                                component={Wysiwyg}
                                type={"text"}
                            />
                        </FormGroup>

                    </div>
                    <button className="btn btn-outline-danger" style={{ marginBottom: '30px' }} onClick={() => fields.remove(i)}>
                        Remove
                            </button>
                </React.Fragment>
            ))}
            <div className={"add-button bottom"}>
                <Button
                    type={"button"}
                    onClick={() => fields.push({ section_type: "" })}
                >
                    Add Question
          </Button>
            </div>
        </div>
    );
};

export default Faq;


// WEBPACK FOOTER //
// ./src/containers/Ships/components/Faq.jsx